import { render, staticRenderFns } from "./myPage.vue?vue&type=template&id=71b56975&"
import script from "./myPage.vue?vue&type=script&lang=ts&"
export * from "./myPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports